import React from 'react';

function Link({icon, caption, href, figureClassName}) {
  return (
    <a href={href ? href : null}>
      <figure className={'mb-0 text-center ' + (figureClassName ? figureClassName : '')}>
        <img src={icon} alt={caption} />
        <figcaption>{caption}</figcaption>
      </figure>
    </a>
  );
}

export default Link;
